import { useMutation, useQuery } from "./helper";
import { getCompanyLogo, updateCompanyLogo } from "../../../api/company";

export const useCompanyLogo = (companyId, options) => useQuery<Blob>({
    queryKey: ['company-logo', companyId],
    queryFn: () => getCompanyLogo(companyId),
    isBlob: true,
    ...options,
});

export const useCompanyLogoUpdate = () => useMutation({
     mutationFn: async ({ companyId, payload }) => await updateCompanyLogo(companyId, payload),
});
